import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default function conditionalComponent(displayName, params) {
  const anyFunc = params.any;
  const allFunc = params.all;
  const propTypes = params.propTypes || {};
  const shouldRenderFunc = params.shouldRender;
  const shouldFailureFunc = params.shouldFailure;

  return createReactClass({
    displayName,

    propTypes: Object.assign(
      {},
      {
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        render: PropTypes.func,
        failure: PropTypes.func,
        request: PropTypes.object,
        any: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
        all: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
      },
      propTypes
    ),

    contextTypes: {
      manager: PropTypes.object,
      request: PropTypes.object,
    },

    render() {
      const {
        request,
        any,
        all,
      } = this.props;
      let shouldRender = false;
      let shouldFailure = false;
      let rendered = null;

      if (typeof request !== 'undefined' || typeof this.context.request !== 'undefined') {
        const thisRequest = request || this.context.request;
        shouldRender = this.context.manager.requests[allFunc]([thisRequest]);
      }

      if (typeof any !== 'undefined') {
        shouldRender = this.context.manager.requests[anyFunc](any);
        shouldFailure = this.context.manager.requests.anyFailed(any);
      }

      if (typeof all !== 'undefined') {
        shouldRender = this.context.manager.requests[allFunc](all);
        shouldFailure = this.context.manager.requests.anyFailed(all);
      }

      if (typeof shouldRenderFunc === 'function') {
        // Delegate to the component
        shouldRender = shouldRenderFunc.bind(this)(shouldRender);
      }

      if (typeof shouldFailureFunc === 'function') {
        // Delegate to the component
        shouldFalure = shouldFailureFunc.bind(this)(shouldFailure);
      }

      if (this.props.failure && shouldFailure) {
        rendered = this.props.failure() || null;
      } else if (this.props.render && shouldRender && !shouldFailure) {
        rendered = this.props.render() || null;
      } else if (shouldRender) {
        if (React.Children.count(this.props.children) === 1) {
          rendered = this.props.children;
        } else {
          rendered = (
            <div>
              {this.props.children}
            </div>
          );
        }
      }

      return rendered;
    },
  });
}



// WEBPACK FOOTER //
// ./app/javascript/requests/components/conditionalComponent.js